import React from "react";
import { createRoot } from "react-dom/client";
import ScrollStack, { ScrollStackItem } from "./ScrollStack";

export function mountServiceStacks(root = document) {
	root.querySelectorAll("[data-service-stack]").forEach(element => {
		if (element.dataset.mounted) return;
		const services = [...element.querySelectorAll("article")].map(card => ({
			number: card.querySelector(".num, .studio-card-number")?.textContent.trim() || "",
			title: card.querySelector("h2, h3")?.textContent.trim() || "",
			description: card.querySelector("p")?.textContent.trim() || "",
			url: card.querySelector("a")?.getAttribute("href") || "#",
		}));
		if (!services.length) return;
		element.dataset.mounted = "true";
		element.classList.add("has-scroll-stack");
		createRoot(element).render(
			<ScrollStack useWindowScroll itemDistance={72} itemStackDistance={14}
				stackPosition="120px" scaleEndPosition="80px" baseScale={0.9} itemScale={0.02}>
				{services.map(service => <ScrollStackItem key={service.url}>
					<article className="card scroll-stack-card__grid">
						<div className="scroll-stack-card__col scroll-stack-card__col--left">
							<div className="num">{service.number}</div>
							<h2>{service.title}</h2>
						</div>
						<div className="scroll-stack-card__col scroll-stack-card__col--right">
							<p>{service.description}</p>
							<a className="link" href={service.url}>Explore service <span>↗</span></a>
						</div>
					</article>
				</ScrollStackItem>)}
			</ScrollStack>
		);
	});
}
